import api, { OFFER_SLOTS } from "./api";

export const updateMeetingSlotStatus = async (offerSlotId, body) => {
  return await api.put(`${OFFER_SLOTS}/${offerSlotId}`, body);
};

export const addofferSlotIdOnMeetingLink = async (offerSlotId, body) => {
  return await api.put(`${OFFER_SLOTS}/${offerSlotId}`, body);
};

export const fetchOfferSlotsByOfferSlotId = async (offerSlotId) => {
  return await api.get(`${OFFER_SLOTS}/${offerSlotId}`);
};
